import { POST } from "../../index";

export const selectMenuNode = (param) => POST("/v1/menuNode/selectMenuNode", param);
export const addModule = (param) => POST("/v1/menuNode/addModule", param);
export const addMenuNode = (param) => POST("/v1/menuNode/addMenuNode", param);
export const updateMenuNode = (param) => POST("/v1/menuNode/updateMenuNode", param);
export const deleteMenuNode = (param) => POST("/v1/menuNode/deleteMenuNode", param);
